// Single definition of "this session is dead": wipe the local session and send the browser back to
// the login screen. Every REST client in the dashboard (main, payments, v2, contact-io) funnels its
// invalid-session branch through here, so a new client cannot silently skip the logout and leave the
// user clicking around with a token the server already rejects.
export const UNAUTHORIZED_MESSAGE = 'UNAUTHORIZED';

export const endUnauthorizedSession = () => {
  localStorage.clear();
  window.location.replace('/');
};

// The legacy backend answers `{ userMessage: "UNAUTHORIZED" }` (sometimes as the bare body), while
// contact-io answers a 401 with a Spanish message under `error`. Both mean the same thing.
export const isUnauthorizedResponse = (error) => {
  if (error?.response?.status === 401) return true;
  const data = error?.response?.data;
  return (data?.userMessage || data) === UNAUTHORIZED_MESSAGE;
};

export default endUnauthorizedSession;
